import React, { FunctionComponent } from "react";

const DrawerDownloadIcon: FunctionComponent = () => {
  // https://www.streamlinehq.com/icons/streamline-regular/emails/drawers/drawer-download
  return (
    <svg viewBox="-0.75 -0.75 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.095 14.0625a5.5790625 5.5790625 0 0 1 -9.69 0H2.8125a1.40625 1.40625 0 0 0 -1.40625 1.40625V19.6875A1.40625 1.40625 0 0 0 2.8125 21.09375h16.875a1.40625 1.40625 0 0 0 1.40625 -1.40625v-4.21875A1.40625 1.40625 0 0 0 19.6875 14.0625Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="m11.25 11.25 0 -9.84375"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
      <path
        d="M7.734375 8.4375 11.25 11.25l3.515625 -2.8125"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default DrawerDownloadIcon;
